import { render, staticRenderFns } from "./TrafficGoals.vue?vue&type=template&id=1b3d1838&scoped=true&"
import script from "./TrafficGoals.vue?vue&type=script&lang=js&"
export * from "./TrafficGoals.vue?vue&type=script&lang=js&"
import style0 from "./TrafficGoals.vue?vue&type=style&index=0&id=1b3d1838&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3d1838",
  null
  
)

export default component.exports